import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';

export const tasksService = {
  all: (reportId, queryParams = null) => {
    return fetch(`/api/time_tracking/claim_project_reports/${reportId}/tracking_tasks?${queryParams}`, request.get);
  }
};
